/* ============================================================
   AI Chat i18n — gofor360
   Locale detection + translation dictionary for IT / EN / DE / ES.

   Usage:
     AII18n.locale          → "it" | "en" | "de" | "es"
     AII18n.t('key')        → translated string (falls back to IT)
     AII18n.url('/products/x') → "/en/products/x" on non-primary locales
   ============================================================ */

window.AII18n = (function () {
  'use strict';

  const PRIMARY = 'it';
  const SUPPORTED = ['it', 'en', 'de', 'es'];

  function detectLocale() {
    // 1. Shopify's own global (most reliable)
    try {
      const s = window.Shopify && window.Shopify.locale;
      if (s && SUPPORTED.includes(s.slice(0, 2))) return s.slice(0, 2);
    } catch (e) {}
    // 2. <html lang="...">
    const htmlLang = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
    if (SUPPORTED.includes(htmlLang)) return htmlLang;
    // 3. URL path prefix (/en/... /de/... /es/...)
    const seg = window.location.pathname.split('/')[1];
    if (SUPPORTED.includes(seg)) return seg;
    return PRIMARY;
  }

  const locale = detectLocale();
  // Path prefix: "" on the primary locale, "/en" etc. elsewhere
  const prefix = locale === PRIMARY ? '' : '/' + locale;

  const DICT = {
    it: {
      // Hero
      heroEyebrow:      'Powered by AI · Prodotti formulati con farmacisti',
      heroHeading:      'Come posso aiutarti con il tuo benessere?',
      heroSubheading:   'Chiedimi di integratori, ingredienti, obiettivi di salute o consigli personalizzati.',
      inputPlaceholder: 'Scrivi una domanda o aggiungi un prodotto',
      scrollHint:       'Scopri di più',
      chip1: 'Aiutami a dormire meglio',
      chip2: 'Ho bisogno di più energia',
      chip3: 'Quale integratore fa per me?',
      chip4: 'Confronta i magnesi',
      chip1Prompt: 'Quali integratori naturali mi consigliate per dormire meglio?',
      chip2Prompt: 'Sono spesso stanco. Quali integratori mi consigliate per più energia e focus?',
      chip3Prompt: "Aiutami a scegliere l'integratore giusto per me. Fammi qualche domanda.",
      chip4Prompt: 'Qual è la differenza tra i vostri integratori a base di magnesio?',
      // Chat page
      backHome:         'Home',
      assistantName:    'Assistente gofor360',
      resetChat:        'Nuova conversazione',
      chatPlaceholder:  'Scrivi una domanda...',
      disclaimer:       'Le risposte sono indicative e non sostituiscono un consulto medico. Consulta il farmacista o il medico per dubbi.',
      greeting:         "Ciao! Sono l'assistente gofor360. Dimmi un sintomo, un obiettivo, o cosa stai cercando — ti consiglio gli integratori più adatti.",
      resetDone:        'Conversazione azzerata. Cosa stavi cercando?',
      errorGeneric:     "Mi dispiace, c'è un problema tecnico. Riprova tra un momento o scrivici su WhatsApp.",
      // Product cards
      addToCart:        'Aggiungi',
      adding:           'Aggiungo...',
      added:            'Aggiunto',
      retry:            'Riprova',
      loading:          'Caricamento...',
      // Search dropdown
      searchHeader:     'Prodotti',
      askAssistant:     "Chiedi all'assistente:",
      addProduct:       'Aggiungi prodotto',
      send:             'Invia'
    },

    en: {
      heroEyebrow:      'Powered by AI · Products formulated with pharmacists',
      heroHeading:      'How can I help with your wellbeing?',
      heroSubheading:   'Ask me about supplements, ingredients, health goals or personalised advice.',
      inputPlaceholder: 'Ask a question or add a product',
      scrollHint:       'Discover more',
      chip1: 'Help me sleep better',
      chip2: 'I need more energy',
      chip3: 'Which supplement is right for me?',
      chip4: 'Compare magnesium products',
      chip1Prompt: 'Which natural supplements do you recommend to sleep better?',
      chip2Prompt: "I'm often tired. Which supplements do you recommend for more energy and focus?",
      chip3Prompt: 'Help me pick the right supplement for me. Ask me a few questions.',
      chip4Prompt: 'What is the difference between your magnesium supplements?',
      backHome:         'Home',
      assistantName:    'gofor360 Assistant',
      resetChat:        'New conversation',
      chatPlaceholder:  'Ask a question...',
      disclaimer:       'These answers are indicative and do not replace medical advice. Talk to your pharmacist or doctor if in doubt.',
      greeting:         "Hi! I'm the gofor360 assistant. Tell me a symptom, a goal, or what you're looking for — I'll suggest the most suitable supplements.",
      resetDone:        'Conversation cleared. What were you looking for?',
      errorGeneric:     "Sorry, there's a technical problem. Please try again shortly or message us on WhatsApp.",
      addToCart:        'Add',
      adding:           'Adding...',
      added:            'Added',
      retry:            'Retry',
      loading:          'Loading...',
      searchHeader:     'Products',
      askAssistant:     'Ask the assistant:',
      addProduct:       'Add product',
      send:             'Send'
    },

    de: {
      heroEyebrow:      'Powered by AI · Mit Apothekern formulierte Produkte',
      heroHeading:      'Wie kann ich dir bei deinem Wohlbefinden helfen?',
      heroSubheading:   'Frag mich nach Nahrungsergänzung, Inhaltsstoffen, Gesundheitszielen oder persönlicher Beratung.',
      inputPlaceholder: 'Stelle eine Frage oder füge ein Produkt hinzu',
      scrollHint:       'Mehr entdecken',
      chip1: 'Hilf mir besser zu schlafen',
      chip2: 'Ich brauche mehr Energie',
      chip3: 'Welches Produkt passt zu mir?',
      chip4: 'Magnesium vergleichen',
      chip1Prompt: 'Welche natürlichen Nahrungsergänzungsmittel empfehlt ihr für besseren Schlaf?',
      chip2Prompt: 'Ich bin oft müde. Welche Produkte empfehlt ihr für mehr Energie und Konzentration?',
      chip3Prompt: 'Hilf mir, das richtige Produkt für mich zu finden. Stell mir ein paar Fragen.',
      chip4Prompt: 'Was ist der Unterschied zwischen euren Magnesium-Produkten?',
      backHome:         'Startseite',
      assistantName:    'gofor360 Assistent',
      resetChat:        'Neues Gespräch',
      chatPlaceholder:  'Stelle eine Frage...',
      disclaimer:       'Diese Antworten sind unverbindlich und ersetzen keine ärztliche Beratung. Sprich bei Fragen mit deinem Apotheker oder Arzt.',
      greeting:         'Hallo! Ich bin der gofor360 Assistent. Nenne mir ein Symptom, ein Ziel oder wonach du suchst — ich empfehle dir die passenden Produkte.',
      resetDone:        'Gespräch zurückgesetzt. Wonach hast du gesucht?',
      errorGeneric:     'Entschuldige, es gibt ein technisches Problem. Versuche es gleich noch einmal oder schreib uns auf WhatsApp.',
      addToCart:        'Hinzufügen',
      adding:           'Wird hinzugefügt...',
      added:            'Hinzugefügt',
      retry:            'Erneut versuchen',
      loading:          'Wird geladen...',
      searchHeader:     'Produkte',
      askAssistant:     'Frag den Assistenten:',
      addProduct:       'Produkt hinzufügen',
      send:             'Senden'
    },

    es: {
      heroEyebrow:      'Powered by AI · Productos formulados con farmacéuticos',
      heroHeading:      '¿Cómo puedo ayudarte con tu bienestar?',
      heroSubheading:   'Pregúntame sobre suplementos, ingredientes, objetivos de salud o consejos personalizados.',
      inputPlaceholder: 'Escribe una pregunta o añade un producto',
      scrollHint:       'Descubre más',
      chip1: 'Ayúdame a dormir mejor',
      chip2: 'Necesito más energía',
      chip3: '¿Qué suplemento es para mí?',
      chip4: 'Comparar magnesios',
      chip1Prompt: '¿Qué suplementos naturales me recomendáis para dormir mejor?',
      chip2Prompt: 'Estoy cansado a menudo. ¿Qué suplementos me recomendáis para más energía y concentración?',
      chip3Prompt: 'Ayúdame a elegir el suplemento adecuado para mí. Hazme algunas preguntas.',
      chip4Prompt: '¿Cuál es la diferencia entre vuestros suplementos de magnesio?',
      backHome:         'Inicio',
      assistantName:    'Asistente gofor360',
      resetChat:        'Nueva conversación',
      chatPlaceholder:  'Escribe una pregunta...',
      disclaimer:       'Estas respuestas son orientativas y no sustituyen el consejo médico. Consulta a tu farmacéutico o médico si tienes dudas.',
      greeting:         '¡Hola! Soy el asistente de gofor360. Dime un síntoma, un objetivo o qué estás buscando — te recomiendo los suplementos más adecuados.',
      resetDone:        'Conversación reiniciada. ¿Qué estabas buscando?',
      errorGeneric:     'Lo siento, hay un problema técnico. Inténtalo de nuevo en un momento o escríbenos por WhatsApp.',
      addToCart:        'Añadir',
      adding:           'Añadiendo...',
      added:            'Añadido',
      retry:            'Reintentar',
      loading:          'Cargando...',
      searchHeader:     'Productos',
      askAssistant:     'Pregunta al asistente:',
      addProduct:       'Añadir producto',
      send:             'Enviar'
    }
  };

  function t(key) {
    const table = DICT[locale] || DICT[PRIMARY];
    return (key in table) ? table[key] : (DICT[PRIMARY][key] || '');
  }

  /**
   * Prefix an internal path with the locale segment.
   *   url('/products/mag-5')  → '/products/mag-5'      (it)
   *                           → '/en/products/mag-5'   (en)
   * Absolute URLs and already-prefixed paths are returned untouched.
   */
  function url(path) {
    if (!path) return path;
    if (/^https?:\/\//i.test(path)) return path;
    if (!prefix) return path;
    // already localised?
    const seg = path.split('/')[1];
    if (SUPPORTED.includes(seg)) return path;
    return prefix + (path.startsWith('/') ? path : '/' + path);
  }

  return { locale, prefix, t, url, isPrimary: locale === PRIMARY, supported: SUPPORTED };
})();
